import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withPropsOnChange } from 'recompose';
import { defaultMemoize } from 'reselect';
import _noop from 'lodash/noop';
import _get from 'lodash/get';

// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';

// Components
import BaseTable from '../table/BaseTable';
import TABLE_ACTION_TYPES from './constants/TableInputField.actionTypes';

// Helpers
import { mapFieldToTableProps, getColumnIdFromAction, shouldAddNewRow, getExpandedFromValues } from './TableInputField.helpers';
var PROPS_TO_WATCH = ['columns'];
var ROW_HEIGHT = 40;
function getTableInputField() {
  var TableComponent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BaseTable;
  var TableInputField = /*#__PURE__*/function (_Component) {
    _inherits(TableInputField, _Component);
    var _super = _createSuper(TableInputField);
    function TableInputField() {
      var _this;
      _classCallCheck(this, TableInputField);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "_getTdProps", defaultMemoize(function (cellConfigurationMap,
      // value,
      additional, error, id) {
        return {
          onAction: _this.handleAction,
          cellConfigurationMap: cellConfigurationMap,
          // tableValues: value,
          tableErrors: error,
          /**
           * Use this particular prop when you want to pass additional data to the table cells without having to deep change the columns array every time.
           * This is done to save the complex computation of columns again and again.
           */
          additional: additional,
          tableFieldId: id
        };
      }));
      _defineProperty(_assertThisInitialized(_this), "getTdProps", function () {
        var _this$props = _this.props,
          cellConfigurationMap = _this$props.cellConfigurationMap,
          additional = _this$props.additional,
          error = _this$props.error,
          id = _this$props.id;
        return _this._getTdProps(cellConfigurationMap,
        // value,
        additional, error, id);
      });
      _defineProperty(_assertThisInitialized(_this), "onRowClick", function (rowData) {
        var _this$props2 = _this.props,
          id = _this$props2.id,
          onAction = _this$props2.onAction;
        onAction({
          type: TABLE_ACTION_TYPES.TABLE_ROW_CLICK,
          payload: {
            id: id,
            data: rowData
          }
        });
      });
      _defineProperty(_assertThisInitialized(_this), "getShouldUpdate", defaultMemoize(function (error, additional) {
        return {
          error: error,
          additional: additional
        };
      }));
      _defineProperty(_assertThisInitialized(_this), "getSubRowProps", function () {
        var _this$props3 = _this.props,
          defaultExpanded = _this$props3.defaultExpanded,
          SubComponent = _this$props3.SubComponent,
          value = _this$props3.value,
          subRowsKey = _this$props3.subRowsKey,
          expanded = _this$props3.expanded;
        if (subRowsKey) {
          return {
            defaultExpanded: defaultExpanded,
            expanded: getExpandedFromValues(value, subRowsKey),
            subRowsKey: subRowsKey
          };
        }
        if (SubComponent) return {
          SubComponent: SubComponent,
          expanded: expanded
        };
        return EMPTY_OBJECT;
      });
      _defineProperty(_assertThisInitialized(_this), "handleAction", function () {
        var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
        var _this$props4 = _this.props,
          value = _this$props4.value,
          _this$props4$shouldAd = _this$props4.shouldAddNewRow,
          shouldAddNewRowFromProps = _this$props4$shouldAd === void 0 ? shouldAddNewRow : _this$props4$shouldAd,
          error = _this$props4.error;
        var shouldAddNewRowHandler = shouldAddNewRowFromProps || shouldAddNewRow;
        var addNewRow = shouldAddNewRowHandler(action.payload, value, error);
        _this.handleCellAction(action);
        if (addNewRow) {
          _this.handleAddNewRow();
        }
      });
      return _this;
    }
    _createClass(TableInputField, [{
      key: "handleCellAction",
      value: function handleCellAction() {
        var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
        var _this$props5 = this.props,
          id = _this$props5.id,
          onAction = _this$props5.onAction;
        var columnId = getColumnIdFromAction(action);
        onAction({
          type: action.type,
          payload: _objectSpread(_objectSpread({}, action.payload), {}, {
            id: id,
            columnId: columnId
          })
        });
      }
    }, {
      key: "handleAddNewRow",
      value: function handleAddNewRow() {
        var _this$props6 = this.props,
          id = _this$props6.id,
          onAction = _this$props6.onAction;
        onAction({
          type: TABLE_ACTION_TYPES.TABLE_ADD_NEW_ROW,
          payload: {
            id: id
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props7 = this.props,
          columnConfigs = _this$props7.columnConfigs,
          value = _this$props7.value,
          error = _this$props7.error,
          className = _this$props7.className,
          additional = _this$props7.additional,
          customTableComponentProps = _this$props7.customTableComponentProps,
          onAction = _this$props7.onAction,
          defaultPageSize = _this$props7.defaultPageSize,
          getTbodyProps = _this$props7.getTbodyProps,
          showPagination = _this$props7.showPagination,
          tableTrGroupKey = _this$props7.tableTrGroupKey,
          getTableRowKey = _this$props7.getTableRowKey,
          subRowsKey = _this$props7.subRowsKey,
          TrComponent = _this$props7.TrComponent,
          TbodyComponent = _this$props7.TbodyComponent,
          rowHeight = _this$props7.rowHeight,
          getTrProps = _this$props7.getTrProps,
          pageSize = _this$props7.pageSize,
          EmptyPlaceholder = _this$props7.EmptyPlaceholder;
        return /*#__PURE__*/React.createElement(TableComponent, _extends({}, customTableComponentProps(onAction), this.getSubRowProps(value, subRowsKey), {
          shouldUpdate: this.getShouldUpdate(error, additional),
          collapseOnDataChange: false,
          columns: columnConfigs,
          data: value,
          pageSize: pageSize || _get(value, 'length', 0),
          rowHeight: rowHeight,
          onRowClick: this.onRowClick,
          getTdProps: this.getTdProps,
          className: className,
          defaultPageSize: defaultPageSize,
          getTbodyProps: getTbodyProps,
          showPagination: showPagination,
          tableTrGroupKey: tableTrGroupKey,
          getTableRowKey: getTableRowKey,
          TrComponent: TrComponent,
          TbodyComponent: TbodyComponent,
          getTrProps: getTrProps,
          EmptyPlaceholder: EmptyPlaceholder
        }));
      }
    }]);
    return TableInputField;
  }(Component);
  TableInputField.propTypes = {
    additional: PropTypes.object,
    cellConfigurationMap: PropTypes.object,
    columnConfigs: PropTypes.array.isRequired,
    defaultExpanded: PropTypes.object,
    SubComponent: PropTypes.func,
    id: PropTypes.string.isRequired,
    onAction: PropTypes.func,
    subRowsKey: PropTypes.string,
    value: PropTypes.array,
    error: PropTypes.array,
    shouldAddNewRow: PropTypes.func.isRequired,
    customTableComponentProps: PropTypes.func,
    className: PropTypes.string,
    defaultPageSize: PropTypes.number,
    getTbodyProps: PropTypes.func,
    getTrProps: PropTypes.func,
    showPagination: PropTypes.bool,
    tableTrGroupKey: PropTypes.string,
    showKebabAlways: PropTypes.bool,
    getTableRowKey: PropTypes.func,
    TbodyComponent: PropTypes.element,
    TrComponent: PropTypes.element,
    expanded: PropTypes.object,
    pageSize: PropTypes.number,
    rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    EmptyPlaceholder: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
  };
  TableInputField.defaultProps = {
    additional: EMPTY_OBJECT,
    cellConfigurationMap: EMPTY_OBJECT,
    defaultExpanded: EMPTY_OBJECT,
    SubComponent: undefined,
    onAction: _noop,
    subRowsKey: '',
    value: EMPTY_ARRAY,
    error: EMPTY_ARRAY,
    customTableComponentProps: _noop,
    className: '',
    defaultPageSize: 20,
    getTbodyProps: undefined,
    showPagination: false,
    showKebabAlways: false,
    tableTrGroupKey: '',
    getTableRowKey: undefined,
    TbodyComponent: undefined,
    TrComponent: undefined,
    pageSize: undefined,
    rowHeight: ROW_HEIGHT,
    expanded: undefined,
    getTrProps: _noop,
    EmptyPlaceholder: undefined
  };
  return withPropsOnChange(PROPS_TO_WATCH, mapFieldToTableProps)(TableInputField);
}
export default getTableInputField(BaseTable);
export { getTableInputField };